import en from './locale/en.json';
import zh_CN from './locale/zh_CN.json';
import zh_TW from './locale/zh_TW.json';

export default {
  en,
  zh_CN,
  zh_TW,
};
